export default {
    markdown: {
        description:
            'You can use the markdown option to customize text descriptions using the markdown format.',
        type: 'string',
    },
};
